
// This file is generated by esbuild to expose the worker script as a class, like Webpack's worker-loader
class GatewayClientWorker {
    constructor() {
        // This path depends on how you serve your files
        return new Worker('/static/js/GatewayClientWorker-EVN4VBJO.js');
    }
}
module.exports = GatewayClientWorker;
